import {
    GET_TOOLBOX,
    SET_TOOLBOX,
    UPLOAD_FILE,
    SET_TOOLBOX_POINTS,
    GET_TOOLBOXTYPE_LIST,
} from "./types";
import firebase from "firebase/app";

export const editPoints = (point, tid, ref) => {
    return (dispatch) => {
        dispatch({ type: SET_TOOLBOX_POINTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_TOOLBOX_POINTS.FAIL });
                }

                firebase
                    .database()
                    .ref(`/subjects/toolbox/${tid}/points/`)
                    .update({
                        [ref]: point,
                    });
            });
        } catch (e) {
            dispatch({ type: SET_TOOLBOX_POINTS.FAIL });
        }
    };
};

export const getToolBox = (id) => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOX.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_TOOLBOX.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/toolbox/" + id)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_TOOLBOX.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOOLBOX.FAIL });
        }
    };
};

export const getAllToolboxes = async () => {
    let user = await firebase.auth().onAuthStateChanged(async (user) => {
        return user;
    });
    if (user) {
        let active = await firebase
            .database()
            .ref(`/subjects/toolbox/`)
            .once("value");
        active = active.val();

        return active;
    } else {
        return false;
    }
};

export const setToolbox = (toolbox = false) => {
    return (dispatch) => {
        dispatch({ type: SET_TOOLBOX.REQUEST });

        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                if (toolbox !== false) {
                    if (typeof toolbox.profile["icon_url"] !== "string")
                        toolbox.profile["icon_url"] = await uploadIconImage(
                            toolbox.profile["icon_url"],
                            toolbox.profile["toolbox_topic"]
                        );
                    firebase
                        .database()
                        .ref(`/subjects/toolbox/`)
                        .child(toolbox.profile.toolbox_id)
                        .update(toolbox, (error) => {
                            if (error) {
                                dispatch({ type: SET_TOOLBOX.FAIL });
                            } else dispatch({ type: SET_TOOLBOX.SUCCESS });
                        });
                }
            }
        });
    };
};

export const uploadIconImage = async (imgBlob = "", toolbox_topic = "") => {
    if (imgBlob && toolbox_topic) {
        let imgUploadURL = firebase
            .storage()
            .ref(`/toolboxicon/${toolbox_topic}/iconimg`)
            .put(imgBlob)
            .then(async (snapshot) => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return "";
                }
            })
            .catch(() => {
                return "";
            });
        return imgUploadURL;
    } else {
        return "";
    }
};

export const uploadFile = (toolboxUID, file, callback) => {
    return async (dispatch) => {
        dispatch({ type: UPLOAD_FILE.REQUEST });

        let upload = firebase
            .storage()
            .ref(`toolbox/${toolboxUID}`)
            .child(file.name)
            .put(file);

        upload.on(
            "state_changed",
            (snapshot) => {
                let progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                callback({
                    fileExists: false,
                    inProgress: true,
                    finished: false,
                    error: false,
                    progress: progress,
                    msg: "Upload is " + progress + "% done",
                });
            },
            () => {
                // Handle unsuccessful uploads
                callback({
                    fileExists: false,
                    inProgress: false,
                    finished: false,
                    error: true,
                    msg: "Something went wrong with this upload!",
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            },
            () => {
                //success
                upload.snapshot.ref.getDownloadURL().then((url) => {
                    callback({
                        fileExists: false,
                        inProgress: false,
                        finished: true,
                        error: false,
                        msg: "Success",
                        url,
                    });
                });
            }
        );
    };
};
export const getToolBoxTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOXTYPE_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_TOOLBOXTYPE_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/toolbox_types")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_TOOLBOXTYPE_LIST.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOOLBOXTYPE_LIST.FAIL });
        }
    };
};
